import './AsyncTaskModal.css';

import {
  Button,
  Loading,
  Modal,
  Panel,
  ProgressBar
} from '@elotech/components';

import { useLoading } from '../../hooks';
import { AsyncTask } from '../../type';
import { PreventUnload } from '../prevent-unload';

type AsyncTaskModalProps = {
  asyncTask?: AsyncTask;
  onCancel(): Promise<void>;
};

export const AsyncTaskModal = ({
  asyncTask,
  onCancel
}: AsyncTaskModalProps) => {
  const [loading, setLoading] = useLoading();

  if (!asyncTask) {
    return null;
  }

  return (
    <div className="async-modal">
      <Modal onClose={onCancel} maxWidth="80%">
        <PreventUnload when={asyncTask.running} />
        <Loading loading={loading} />
        <Panel title={asyncTask.title}>
          <div className="content">
            {!!asyncTask.taskIcon && (
              <i className={`icon ${asyncTask.taskIcon}`} />
            )}
            <span className="currentStatus">
              {asyncTask.currentStatus || 'Processando...'}
            </span>
            {!!asyncTask.errorMessage && (
              <span className="errorMessage">{asyncTask.errorMessage}</span>
            )}
            <div className="progress">
              <ProgressBar
                color={asyncTask.errorMessage ? 'negative' : undefined}
                percentualProgresso={Math.round(
                  asyncTask?.total && asyncTask.current
                    ? (100 * asyncTask.current) / asyncTask.total
                    : 100
                )}
              />
              {asyncTask.cancellable && (
                <Button
                  onClick={() => setLoading(onCancel())}
                  disabled={!asyncTask.cancellable && !asyncTask.errorMessage}
                  color="negative"
                >
                  {asyncTask?.errorMessage ? 'Fechar' : 'Cancelar'}
                </Button>
              )}
            </div>
          </div>
        </Panel>
      </Modal>
    </div>
  );
};
